import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';

import LoadReport from './LoadReport';

const LoadReportModal = ({ loadReport, onHide, onSkipItem, show, showConsolidatedLoad }) => (
  <Modal bsSize="large" onHide={onHide} show={show}>
    <Modal.Header>
      <Modal.Title>
        <FontAwesome name="truck" /> Load Report
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <LoadReport
        loadReport={loadReport}
        onSkipItem={onSkipItem}
        showConsolidatedLoad={showConsolidatedLoad}
      />
    </Modal.Body>
    <Modal.Footer>
      <Button onClick={onHide}>Close</Button>
    </Modal.Footer>
  </Modal>
);

export default LoadReportModal;
